// extracted by mini-css-extract-plugin
module.exports = {"orderEditor":"styles_orderEditor__2-fpn","leftBlock":"styles_leftBlock__3BSqK","sidebarBlock":"styles_sidebarBlock__3pK9Z"};